export function CoreCtrl (
  $scope,
  assemblyPaymentsApi,
  inheritorApi
) {
  inheritorApi.inheritCtrl('CoreLiteCtrl', $scope);

  assemblyPaymentsApi.init();
}
